// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"9e97b45e","432":"257f80e0","453":"9b2ababd","459":"6e87aeb3","533":"0d6874fb","658":"5a2512b4","710":"e0205af1","779":"8a311056","895":"cfc2da0e","928":"4e1b4c49"}[chunkId] + ".chunk.js";
};